import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            passwordsDoNotMatchErrorMessage: String
        };
    }

    static get targets() {
        return [
            "passwordInput",
            "passwordConfirmationInput",
            "passwordsDoNotMatchErrorMessage",
            "hasLowerAndUpperCaseCharactersIcon",
            "hasNumericCharactersIcon",
            "hasSpecialCharactersIcon",
            "hasSufficientCharactersIcon",
            "nextButton"
        ];
    }

    checkPasswordStrength() {
        [
            [this.hasLowerAndUpperCaseCharactersIconTarget, /[A-Z]/.test(this.passwordInputTarget.value) && /[a-z]/.test(this.passwordInputTarget.value)],
            [this.hasNumericCharactersIconTarget, /[0-9]/.test(this.passwordInputTarget.value)],
            [this.hasSpecialCharactersIconTarget, /[!,%,&,@,#,$,^,*,?,_,~]/.test(this.passwordInputTarget.value)],
            [this.hasSufficientCharactersIconTarget, this.passwordInputTarget.value.length >= 8]
        ].forEach(([iconTarget, isValid]) => {
            iconTarget.textContent = isValid ? "check_circle" : "cancel";
            iconTarget.classList.toggle("text-success", isValid);
        });
        this.enableNextButton();
    }

    checkPasswordsMatch() {
        const hasMatchingPasswords = this.passwordInputTarget.value.length > 0 && this.passwordInputTarget.value !== this.passwordConfirmationInputTarget.value;
        this.passwordsDoNotMatchErrorMessageTarget.textContent = hasMatchingPasswords ? this.passwordsDoNotMatchErrorMessageValue : "";
        this.passwordsDoNotMatchErrorMessageTarget.classList.toggle("field-validation-error", hasMatchingPasswords);
        this.enableNextButton();
    }

    enableNextButton() {
        this.nextButtonTarget.disabled =
            ![
                this.hasLowerAndUpperCaseCharactersIconTarget,
                this.hasNumericCharactersIconTarget,
                this.hasSpecialCharactersIconTarget,
                this.hasSufficientCharactersIconTarget
            ].every(it => it.classList.contains("text-success")) || this.passwordsDoNotMatchErrorMessageTarget.classList.contains("field-validation-error");
    }
}